const CollectionTypes = {
  STAV: "STAV",
  ODLUKA: "ODLUKA",
  PRAVNO_SHVATANJE: "PRAVNO_SHVATANJE"
};

const SearchTypes = {
  SIMPLE: "simple",
  ADVANCED: "advanced"
};

const FILTER_START_YEAR = 2010;
const SEARCH_SORT_FIELDS = ["score", "summary", "date_dt"];
export { CollectionTypes, SearchTypes, FILTER_START_YEAR, SEARCH_SORT_FIELDS };
